/* Ability Warehouse — Product Match: describe what's hard, or narrow by where / what's hard / budget / who. Uses the shared product index (CWIndex). */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-match]');
  if (!root || !window.CWIndex) return;
  var X = window.CWIndex;
  var $ = function (s) { return root.querySelector(s); };
  var full = root.dataset.layout === 'full';
  var finderUrl = root.dataset.finderUrl || '/pages/shop-the-home';
  var cfg = window.CW || {};

  /* ---------- helpers over an index item: shared with the collection chooser (assets/aw-understand.js) ---------- */
  var U = window.AWUnderstand;
  if (!U) return;
  var T = U.tests;
  function dollars(it) { return (it.per || it.p) / 100; }

  var ICON = {
    bath: '<path d="M5 13h22v3a7 7 0 0 1-7 7h-8a7 7 0 0 1-7-7z"/><path d="M8 13V7a3 3 0 0 1 6 0"/><path d="M10 23l-1 3M22 23l1 3"/>',
    toilet: '<path d="M9 5h10v9H9z"/><path d="M6 14h20a7 7 0 0 1-7 7h-6a7 7 0 0 1-7-7z"/><path d="M11 21l-1 5M21 21l1 5"/>',
    bed: '<path d="M4 20V9h24v11"/><path d="M4 15h24"/><path d="M8 9V6h16v3"/><path d="M4 20v4M28 20v4"/>',
    walk: '<circle cx="18" cy="6" r="2.5"/><path d="M15 12l3-2 4 3 3 4M12 27l4-9 3 2 2 7"/><path d="M8 14v13"/>',
    home: '<path d="M6 26V12l10-7 10 7v14"/><path d="M13 26v-8h6v8"/>',
    stand: '<circle cx="16" cy="6" r="2.5"/><path d="M12 12h8l-2 8h-4z"/><path d="M14 20l-2 7M18 20l2 7"/><path d="M6 14l4-1M26 14l-4-1"/>',
    shower: '<path d="M8 6h8a6 6 0 0 1 6 6v2"/><path d="M18 14h8"/><path d="M19 18v2M22 18v3M25 18v2M16 18v3M13 18v2"/><path d="M6 26h20"/>',
    transfer: '<circle cx="10" cy="7" r="2.5"/><path d="M6 14h8v8H6z"/><path d="M18 11h8M22 7l4 4-4 4"/><path d="M20 26h8"/>',
    reach: '<circle cx="10" cy="6" r="2.5"/><path d="M8 11h4l3 9h-5z"/><path d="M12 11l10 2"/><path d="M22 13l4-2"/><path d="M8 27l2-7M14 27l-1-7"/>',
    cont: '<path d="M16 5c-4 6-7 9-7 14a7 7 0 0 0 14 0c0-5-3-8-7-14z"/>',
    pain: '<path d="M16 27s-10-6-10-13a5.5 5.5 0 0 1 10-3 5.5 5.5 0 0 1 10 3c0 7-10 13-10 13z"/><path d="M10 15h3l2-4 2 8 2-4h3"/>',
    alert: '<path d="M16 4l12 22H4z"/><path d="M16 12v6"/><circle cx="16" cy="22" r="1.2" fill="currentColor"/>',
    me: '<circle cx="16" cy="9" r="5"/><path d="M6 27a10 10 0 0 1 20 0"/>',
    carer: '<circle cx="11" cy="9" r="4"/><circle cx="22" cy="11" r="3"/><path d="M4 26a7 7 0 0 1 14 0"/><path d="M17 26a5 5 0 0 1 10 0"/>',
    client: '<rect x="5" y="8" width="22" height="18" rx="2"/><path d="M11 8V5h10v3"/><path d="M9 15h14M9 20h8"/>'
  };

  /* ---------- the steps ---------- */
  var steps = [
    {
      key: 'where', q: 'Where is it needed?', hint: 'Pick one', single: true, kind: 'icon',
      opts: [
        { v: 'bathroom', l: 'Bathroom', ic: 'bath', test: T.where.bathroom,
          tip: 'Wet areas: look for rubber feet, a weight rating above the user\'s weight, and a seat height close to their lower-leg length. Anything fixed to a tiled wall needs the right anchors.' },
        { v: 'toilet', l: 'Toilet', ic: 'toilet', test: T.where.toilet,
          tip: 'Measure the gap each side of the toilet before choosing a frame, and check the seat height the user can stand from. Raised seats come in 5, 10 and 15 cm.' },
        { v: 'bedroom', l: 'Bedroom', ic: 'bed', test: T.where.bedroom,
          tip: 'Bed rails and sticks need a firm mattress base; check the bed type. Mattress protectors come in single, double and king single.' },
        { v: 'walking', l: 'Getting around', ic: 'walk', test: T.where.walking,
          tip: 'Check the narrowest doorway the walker or chair must pass, and the user\'s height for handle height. Outdoor use needs bigger wheels.' },
        { v: 'home', l: 'Around the home', ic: 'home', test: T.where.home,
          tip: 'Daily-living aids are mostly low-cost items. Smart-home devices need Wi-Fi and a phone or tablet to set up.' }
      ]
    },
    {
      key: 'what', q: 'What\'s hard?', hint: 'Pick any', kind: 'icon',
      opts: [
        { v: 'standing', l: 'Standing up', ic: 'stand', test: T.what.standing,
          tip: 'Standing aids work best when the hands push down, not pull: a toilet frame or lift chair beats a grab rail alone.' },
        { v: 'showering', l: 'Showering', ic: 'shower', test: T.what.showering,
          tip: 'A shower stool or chair with a back lets the person sit for the whole shower; a bath board bridges the tub. Non-slip mats help everyone.' },
        { v: 'walking', l: 'Walking', ic: 'walk', test: T.what.walking,
          tip: 'Sticks for a light steady, frames for more weight-bearing, rollators for distance and a seat to rest on.' },
        { v: 'transferring', l: 'Transferring', ic: 'transfer', test: T.what.transferring,
          tip: 'Transfer boards and belts suit someone who can bear some weight; hoists and slings are for assisted transfers and should be set up by an OT.' },
        { v: 'reaching', l: 'Reaching', ic: 'reach', test: T.what.reaching,
          tip: 'Long-handled reachers, sock aids and shoe horns stop bending; a 60–80 cm reacher suits most people.' },
        { v: 'continence', l: 'Continence', ic: 'cont', test: T.what.continence,
          tip: 'Pick absorbency by day/night use and the person\'s size. Opened hygiene products cannot be returned, so start with a small pack.' },
        { v: 'pain', l: 'Pain / support', ic: 'pain', test: T.what.pain,
          tip: 'Braces are sized by circumference — measure before you order. For a new injury, see a GP or physio first.' },
        { v: 'safety', l: 'Safety alerts', ic: 'alert', test: T.what.safety,
          tip: 'Fall and door sensors need a phone or Wi-Fi hub to send alerts; pendant alarms work on their own. Ask who will get the alert at 3 am.' }
      ]
    },
    { key: 'budget', q: 'Budget?', hint: 'Drag to set a range', kind: 'range' },
    {
      key: 'who', q: 'Who is it for?', hint: 'Pick one', single: true, kind: 'icon',
      opts: [
        { v: 'me', l: 'Myself', ic: 'me', test: function () { return true; },
          tip: 'Buying for yourself: if you use an NDIS plan, DVA card or Home Care Package, check with your plan manager or funding body first — our tax invoice has the details they need.' },
        { v: 'carer', l: 'Someone I care for', ic: 'carer', test: function () { return true; },
          tip: 'Buying for a family member: order in your name and add their name in the order notes so the invoice suits their plan manager.' },
        { v: 'client', l: 'A client / participant', ic: 'client', test: function () { return true; },
          tip: 'Ordering for a participant? Provider accounts are coming soon — call us and we\'ll place the order and send a tax invoice listing the item and our ABN.' }
      ]
    }
  ];
  /* Home page teaser: where + what's hard, plus an optional "who" row that only re-orders and adds notes (it never filters) */
  function wr(it) { var m = String(it.wr || '').match(/\d+/); return m ? +m[0] : 0; }
  var whatStep = {}; for (var wk in steps[1]) whatStep[wk] = steps[1][wk]; whatStep.q = 'What\'s getting hard?';
  if (!full) steps = [steps[0], whatStep, {
    key: 'who', q: 'Who is it for?', hint: 'optional', kind: 'chip', soft: true,
    opts: [
      { v: 'heavy', l: 'Over 100 kg', test: function () { return true; }, boost: function (it) { return wr(it) >= 120; },
        tip: 'Pick a weight rating comfortably above the user\'s weight. Bariatric products start at 200 kg.' },
      { v: 'renting', l: 'Renting', test: function () { return true; }, boost: function () { return false; },
        tip: 'Anything screwed to a wall needs the landlord\'s OK in writing. Free-standing and clamp-on options — over-toilet frames, bath boards, shower stools — need no drilling at all.' },
      { v: 'small', l: 'Small bathroom', test: function () { return true; }, boost: function () { return false; },
        tip: 'Check the shower recess width against the product width before you order, and measure the gap each side of the toilet before choosing a frame.' }
    ]
  }];
  var byKey = {};
  steps.forEach(function (s) { byKey[s.key] = s; });

  /* ---------- state ---------- */
  var state = { sel: {}, min: 0, max: Infinity, q: '' };
  steps.forEach(function (s) { if (s.opts) state.sel[s.key] = []; });
  var items = [], results = [], sorted = [], shown = 0, MAXP = 500, sort = 'match', pillSync = null, rangeTimer;

  /* words in a typed request → choices: shared table in assets/aw-understand.js */
  var PHRASES = U.PHRASES;

  /* ---------- matching ---------- */
  function stepPasses(it, step) {
    var sel = state.sel[step.key];
    if (!sel || !sel.length) return true;
    for (var i = 0; i < step.opts.length; i++) if (sel.indexOf(step.opts[i].v) > -1 && step.opts[i].test(it)) return true;
    return false;
  }
  function passes(it, skipKey) {
    for (var i = 0; i < steps.length; i++) {
      var s = steps[i];
      if (s.opts && s.key !== skipKey && !stepPasses(it, s)) return false;
    }
    if (skipKey === 'budget') return true;
    var d = dollars(it);
    return d >= state.min && d <= state.max;
  }
  function wordsPass(it) { return !state.q || X.search([it], state.q).length > 0; }
  function anyChosen() { return !!(state.q || state.min > 0 || state.max < Infinity || steps.some(function (s) { return s.opts && state.sel[s.key].length; })); }

  /* typed request → choices + leftover words (parsing lives in assets/aw-understand.js) */
  function understand(raw) {
    var p = U.parse(raw);
    steps.forEach(function (s) { if (s.opts) state.sel[s.key] = []; });
    state.min = p.min; state.max = p.max;
    var picked = p.picked.slice();
    ['where', 'what', 'who'].forEach(function (k) {
      var step = byKey[k];
      if (!step || !step.opts) return;
      p.sel[k].forEach(function (v) {
        if (step.single && state.sel[k].length) return;
        if (!step.opts.some(function (o) { return o.v === v; })) return;
        if (state.sel[k].indexOf(v) < 0) state.sel[k].push(v);
      });
    });
    var left = p.q, rental = p.rental;
    state.q = left;
    var nothing = '';
    if (left && !items.some(function (it) { return passes(it) && wordsPass(it); })) { nothing = left; state.q = ''; }
    var u = $('[data-tm-understood]');
    if (u) {
      u.hidden = !picked.length && !state.q && !nothing && !rental;
      u.innerHTML = (picked.length ? 'We picked: ' + picked.map(function (x) { return '<b>' + X.esc(x) + '</b>'; }).join(' · ') : '') +
        (state.q ? (picked.length ? ' · ' : '') + 'matching “' + X.esc(state.q) + '”' : '') +
        (nothing ? (picked.length ? ' · ' : '') + 'nothing mentions “' + X.esc(nothing) + '”, so here are the closest matches' : '') +
        (rental ? ' · <b>Renting:</b> we\'ve noted it — see the tip on fixing without drilling' : '');
    }
    state.rental = rental;
  }

  /* ---------- rendering ---------- */
  function icon(name) { return '<svg viewBox="0 0 32 32" aria-hidden="true">' + (ICON[name] || '') + '</svg>'; }
  function chipStepHTML(step) {
    var sel = state.sel[step.key] || [];
    var pool = step.soft ? [] : items.filter(function (it) { return passes(it, step.key) && wordsPass(it); });
    var h = '<li class="tml__step" data-step="' + step.key + '"><b class="tml__ask">' + step.q + '<small>' + (step.single ? 'pick one' : step.soft ? 'optional' : 'pick any') + '</small></b><div class="tml__chips">';
    step.opts.forEach(function (o) {
      var n = 0; if (!step.soft) for (var k = 0; k < pool.length; k++) if (o.test(pool[k])) n++;
      var on = sel.indexOf(o.v) > -1, dead = !step.soft && !n && !on;
      h += '<button type="button" class="tm__opt tml__chip' + (on ? ' is-on' : '') + (dead ? ' is-zero' : '') + '" aria-pressed="' + on + '" data-k="' + step.key + '" data-v="' + o.v + '"' + (dead ? ' disabled' : '') + '>' + o.l + '</button>';
    });
    return h + '</div></li>';
  }
  function stepHTML(step, i) {
    if (!full) return chipStepHTML(step);
    var sel = state.sel[step.key] || [];
    var done = step.kind === 'range' ? state.min > 0 || state.max < Infinity : sel.length > 0;
    var h = '<li class="tm__step' + (done ? ' is-done' : '') + '" data-step="' + step.key + '"><div class="tm__step-head"><span class="tm__num">' + (done ? '✓' : i + 1) + '</span><h3 class="tm__q">' + step.q + '</h3><span class="tm__hint">' + step.hint + '</span>' +
      (done ? '<button type="button" class="tm__clear" data-clear="' + step.key + '">Clear</button>' : '') + '</div>';
    if (step.kind === 'range') {
      var lo = state.min, hi = state.max === Infinity ? MAXP : state.max;
      h += '<div class="tm__range" data-range><div class="tm__range-track"><span class="tm__range-fill" data-fill></span></div>' +
        '<input type="range" min="0" max="' + MAXP + '" step="5" value="' + lo + '" data-lo aria-label="Minimum price">' +
        '<input type="range" min="0" max="' + MAXP + '" step="5" value="' + hi + '" data-hi aria-label="Maximum price">' +
        '<div class="tm__range-vals"><b data-lo-v>$' + lo + '</b><span>to</span><b data-hi-v>' + (state.max === Infinity ? '$' + MAXP + '+' : '$' + hi) + '</b><span>each</span></div><div class="tm__quick">' +
        [['Any price', 0, Infinity], ['Under $50', 0, 50], ['$50 – $200', 50, 200], ['$200 – $500', 200, 500], ['$500+', 500, Infinity]].map(function (q) {
          return '<button type="button" class="tm__chip' + (state.min === q[1] && state.max === q[2] ? ' is-on' : '') + '" data-quick="' + q[1] + ',' + (q[2] === Infinity ? '' : q[2]) + '">' + q[0] + '</button>';
        }).join('') + '</div></div>';
      return h + '</li>';
    }
    var pool = items.filter(function (it) { return passes(it, step.key) && wordsPass(it); });
    h += '<div class="tm__opts tm__opts--' + step.kind + '">';
    step.opts.forEach(function (o) {
      var n = 0;
      for (var k = 0; k < pool.length; k++) if (o.test(pool[k])) n++;
      var on = sel.indexOf(o.v) > -1;
      h += '<button type="button" class="tm__opt' + (on ? ' is-on' : '') + (n ? '' : ' is-zero') + '" aria-pressed="' + on + '" data-k="' + step.key + '" data-v="' + o.v + '"' + (n || on ? '' : ' disabled') + '>' +
        '<span class="tm__vis tm__vis--icon">' + icon(o.ic) + '</span><span class="tm__opt-l">' + o.l + (o.sub ? '<small>' + o.sub + '</small>' : '') + '</span><span class="tm__count">' + n + '</span></button>';
    });
    return h + '</div></li>';
  }
  function fillRange() {
    var r = root.querySelector('[data-range]');
    if (!r) return;
    var lo = +r.querySelector('[data-lo]').value, hi = +r.querySelector('[data-hi]').value, f = r.querySelector('[data-fill]');
    f.style.left = (lo / MAXP) * 100 + '%'; f.style.right = 100 - (hi / MAXP) * 100 + '%';
  }
  function whoScore(it) {
    var n = 0, s = byKey.who; if (!s || !s.soft) return 0;
    s.opts.forEach(function (o) { if (state.sel.who.indexOf(o.v) > -1 && o.boost && o.boost(it)) n++; });
    return n;
  }
  function teaserPicksHTML(list) {
    /* Same "best" selection as the finder (best price, biggest saving, newest), limited to four; "who" chips move matching products first */
    if (!list.length) return '';
    var seen = {}, out = [];
    var ranked = list.map(function (it, i) { return { it: it, i: i, w: whoScore(it) }; }).sort(function (a, b) { return b.w - a.w || a.i - b.i; }).map(function (x) { return x.it; });
    function add(it) { if (it && !seen[it.i]) { seen[it.i] = 1; out.push(it); } }
    var live = ranked.filter(function (it) { return it.a; });
    var pool = live.length ? live : ranked;
    var boosted = pool.filter(function (it) { return whoScore(it) > 0; });
    var top = boosted.length ? boosted : pool;
    add(top.slice().sort(function (a, b) { return a.per - b.per; })[0]);
    add(top.slice().sort(function (a, b) { return (b.r - b.p) - (a.r - a.p); })[0]);
    add(top.slice().sort(function (a, b) { return b.d - a.d; })[0]);
    pool.forEach(function (it) { if (out.length < 4) add(it); });
    return out.slice(0, 4).map(function (it) {
      return '<a class="tml__item" href="' + it.url + '"><span class="tml__img">' + (it.im ? '<img src="' + X.img(it.im, 160) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</span>' +
        '<span class="tml__meta"><b>' + X.esc(it.t) + '</b>' + (it.br || it.wr ? '<small>' + X.esc([it.br, it.wr].filter(Boolean).join(' · ')) + '</small>' : '') + '</span>' +
        '<span class="tml__price">' + X.priceHTML(it) + '</span></a>';
    }).join('');
  }
  function picksHTML(list) {
    if (!list.length) return '';
    var seen = {}, out = [];
    function add(it, badge) { if (it && !seen[it.i]) { seen[it.i] = 1; out.push({ it: it, b: badge }); } }
    var live = list.filter(function (it) { return it.a; });
    var pool = live.length ? live : list;
    add(pool.slice().sort(function (a, b) { return a.per - b.per; })[0], 'Best price');
    add(pool.slice().sort(function (a, b) { return (b.r - b.p) - (a.r - a.p); })[0], 'Biggest saving');
    add(pool.slice().sort(function (a, b) { return b.d - a.d; })[0], 'Newest');
    pool.forEach(function (it) { if (out.length < 5) add(it, ''); });
    return out.map(function (o) {
      var it = o.it;
      return '<a class="tm__pick" href="' + it.url + '">' + (o.b ? '<span class="tm__badge tm__badge--' + o.b.toLowerCase().replace(/\s+/g, '-') + '">' + o.b + '</span>' : '') +
        '<span class="tm__pick-img">' + (it.im ? '<img src="' + X.img(it.im, 360) + '" alt="" loading="lazy" width="360" height="360">' : '') + '</span>' +
        '<span class="tm__pick-meta">' + X.esc([it.br, it.wr].filter(Boolean).join(' · ')) + '</span><span class="tm__pick-t">' + X.esc(it.t) + '</span>' +
        '<span class="tm__pick-p"><b>' + X.money(it.per) + '</b>' + (it.r > it.p ? ' <s>' + X.money(it.r) + '</s>' : '') + '</span></a>';
    }).join('');
  }
  function more() {
    var grid = $('[data-tm-grid]');
    if (!grid || shown >= sorted.length) return;
    var h = '';
    sorted.slice(shown, shown + 24).forEach(function (it) { h += X.card(it); });
    grid.insertAdjacentHTML('beforeend', h);
    shown = Math.min(sorted.length, shown + 24);
    var m = $('[data-tm-more]');
    if (m) m.hidden = shown >= sorted.length;
  }
  function query() {
    var u = new URLSearchParams();
    steps.forEach(function (s) { if (s.opts && !s.soft && state.sel[s.key].length) u.set(s.key, state.sel[s.key].join(',')); });
    if (state.min > 0) u.set('min', state.min);
    if (state.max < Infinity) u.set('max', state.max);
    if (state.q) u.set('q', state.q);
    return u.toString();
  }
  function tips() {
    var list = [];
    steps.forEach(function (s) { (s.opts || []).forEach(function (o) { if (o.tip && state.sel[s.key].indexOf(o.v) > -1) list.push({ h: o.l, t: o.tip }); }); });
    if (state.rental) list.unshift({ h: 'Renting', t: 'Anything screwed to a wall needs the landlord\'s OK in writing. Free-standing and clamp-on options — over-toilet frames, bath boards, shower stools — need no drilling at all.' });
    var el = $('[data-tm-tips]');
    if (!full) { el.innerHTML = list.length ? list.slice(-2).map(function (x) { return '<p class="tml__tip"><b>' + X.esc(x.h) + ':</b> ' + x.t + '</p>'; }).join('') : '<p class="tml__tip tml__tip--intro">Tap a few chips — tailored notes appear here.</p>'; return; }
    el.innerHTML = list.length ? list.map(function (x) { return '<div class="tm__tip"><p class="tm__tip-h">' + X.esc(x.h) + '</p><p>' + x.t + '</p></div>'; }).join('')
      : '<p class="tm__tip tm__tip--intro">Tailored notes appear here as you choose — what suits the person, what to measure, and what to ask us.</p>';
  }

  function apply() {
    results = items.filter(function (it) { return passes(it) && wordsPass(it); });
    sorted = results.slice();
    if (sort === 'price-asc') sorted.sort(function (a, b) { return a.per - b.per; });
    else if (sort === 'price-desc') sorted.sort(function (a, b) { return b.per - a.per; });
    else if (sort === 'newest') sorted.sort(function (a, b) { return b.d - a.d; });
    else sorted.sort(function (a, b) { return b.a - a.a; });
    var n = sorted.length, chosen = anyChosen();
    var rk = $('[data-tm-res-kicker]'); if (rk) rk.textContent = chosen ? 'Your shortlist is ready' : 'Results';
    var rt = $('[data-tm-res-title]'); if (rt) rt.innerHTML = chosen ? 'You narrowed <b>' + items.length + '</b> products down to <b class="tm__hl">' + n + '</b>.'
      : '<b class="tm__hl">' + items.length + '</b> products — narrow by where, what\'s hard, budget or who to begin.';
    var tags = [];
    steps.forEach(function (s) { (s.opts || []).forEach(function (o) { if (state.sel[s.key].indexOf(o.v) > -1) tags.push('<button type="button" class="tm__tag" data-k="' + s.key + '" data-v="' + o.v + '"><small>' + s.key + '</small>' + o.l + ' ✕</button>'); }); });
    if (state.min > 0 || state.max < Infinity) tags.push('<button type="button" class="tm__tag" data-clear="budget"><small>budget</small>$' + state.min + ' – ' + (state.max === Infinity ? 'any' : '$' + state.max) + ' ✕</button>');
    if (state.q) tags.push('<button type="button" class="tm__tag" data-clear="q"><small>words</small>“' + X.esc(state.q) + '” ✕</button>');
    var ch = $('[data-tm-chosen]'); if (ch) ch.innerHTML = tags.join('');
    $('[data-tm-picks]').innerHTML = !full ? teaserPicksHTML(sorted) : chosen ? picksHTML(sorted) : picksHTML(sorted.slice(0, 40));
    var cnt = $('[data-tm-count]'); if (cnt) cnt.textContent = n + (n === 1 ? ' match' : ' matches');
    var empty = $('[data-tm-empty]');
    if (empty) empty.hidden = n > 0;
    var go = $('[data-tm-go]');
    if (go) { var qs = query(); go.href = finderUrl + (qs ? '?' + qs : ''); go.textContent = full ? 'See all ' + n + ' matching products →' : 'See all ' + n + ' matches →'; go.hidden = !n; }
    if (full) {
      $('[data-tm-grid]').innerHTML = ''; shown = 0; more();
      var gh = $('[data-tm-gridhead]'); if (gh) gh.hidden = !n;
      var qs2 = query();
      history.replaceState(null, '', location.pathname + (qs2 ? '?' + qs2 : '') + location.hash);
    }
    var pn = $('[data-tm-pill-n]');
    if (pn) { pn.textContent = n; if (pillSync) pillSync(); }
    $('[data-tm-steps]').innerHTML = steps.map(stepHTML).join('');
    fillRange();
    tips();
  }
  function scrollToResults() {
    var top = $('[data-tm-results]').getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0) - 12;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* ---------- events ---------- */
  root.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.matches('[data-lo],[data-hi]')) return;
    var r = el.closest('[data-range]'), lo = r.querySelector('[data-lo]'), hi = r.querySelector('[data-hi]');
    if (+lo.value > +hi.value - 5) { if (el === lo) lo.value = +hi.value - 5; else hi.value = +lo.value + 5; }
    r.querySelector('[data-lo-v]').textContent = '$' + lo.value;
    r.querySelector('[data-hi-v]').textContent = +hi.value >= MAXP ? '$' + MAXP + '+' : '$' + hi.value;
    fillRange();
    clearTimeout(rangeTimer);
    rangeTimer = setTimeout(function () {
      state.min = +lo.value; state.max = +hi.value >= MAXP ? Infinity : +hi.value;
      var which = document.activeElement === lo ? 'lo' : document.activeElement === hi ? 'hi' : null;
      apply();
      if (which) { var f = root.querySelector('[data-' + which + ']'); if (f) f.focus(); }
    }, 250);
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !root.contains(b)) return;
    if (b.matches('.tm__opt, .tm__tag[data-k]')) {
      var k = b.dataset.k, v = b.dataset.v, step = byKey[k], sel = state.sel[k], i = sel.indexOf(v);
      if (i > -1) sel.splice(i, 1); else if (step.single) state.sel[k] = [v]; else sel.push(v);
      apply();
      return;
    }
    if (b.hasAttribute('data-clear')) {
      var c = b.dataset.clear;
      if (c === 'budget') { state.min = 0; state.max = Infinity; }
      else if (c === 'q') { state.q = ''; var qi = $('[data-tm-q]'); if (qi) qi.value = ''; var u = $('[data-tm-understood]'); if (u) u.hidden = true; }
      else state.sel[c] = [];
      apply(); return;
    }
    if (b.hasAttribute('data-quick')) { var p = b.dataset.quick.split(','); state.min = +p[0]; state.max = p[1] === '' ? Infinity : +p[1]; apply(); return; }
    if (b.hasAttribute('data-tm-clear')) {
      steps.forEach(function (s) { if (s.opts) state.sel[s.key] = []; });
      state.min = 0; state.max = Infinity; state.q = ''; state.rental = false;
      var q2 = $('[data-tm-q]'); if (q2) q2.value = '';
      apply(); return;
    }
    if (b.hasAttribute('data-tm-try')) { var inp = $('[data-tm-q]'); inp.value = b.textContent; understand(inp.value); apply(); scrollToResults(); return; }
    if (b.hasAttribute('data-tm-loadmore')) more();
  });
  root.addEventListener('change', function (e) { if (e.target.matches('[data-tm-sort]')) { sort = e.target.value; apply(); } });
  var ask = $('[data-tm-ask]');
  if (ask) ask.addEventListener('submit', function (e) { e.preventDefault(); understand($('[data-tm-q]').value); apply(); scrollToResults(); });

  /* floating "N products — View" pill between the board and the results */
  var pill = $('[data-tm-pill]');
  if (pill && 'IntersectionObserver' in window) {
    var boardIn = false, resIn = false;
    pillSync = function () { pill.hidden = !(boardIn && !resIn && anyChosen()); };
    new IntersectionObserver(function (en) { boardIn = en[0].isIntersecting; pillSync(); }, { threshold: 0.05 }).observe($('.tm__board') || root);
    new IntersectionObserver(function (en) { resIn = en[0].isIntersecting; pillSync(); }, { threshold: 0.05 }).observe($('[data-tm-results]'));
    pill.addEventListener('click', function (e) { e.preventDefault(); scrollToResults(); });
  }
  var sentinel = $('[data-tm-sentinel]');
  if (sentinel && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) more(); }, { rootMargin: '800px 0px' }).observe(sentinel);

  /* ---------- boot ---------- */
  X.load('/collections/all').then(function (list) {
    items = list;
    var maxD = 0;
    items.forEach(function (it) { if (dollars(it) > maxD) maxD = dollars(it); });
    MAXP = Math.min(2000, Math.max(500, 100 * Math.ceil(maxD / 100)));
    var brands = {};
    items.forEach(function (it) { if (it.br) brands[it.br] = 1; });
    var st = $('[data-tm-stats]');
    if (st) st.innerHTML = '<b>' + items.length + '</b> products · <b>' + Object.keys(brands).length + '</b> brands · members save on <b>most products</b>';
    if (full) {
      var u = new URLSearchParams(location.search);
      steps.forEach(function (s) {
        if (!s.opts) return;
        var v = u.get(s.key);
        if (v) state.sel[s.key] = v.split(',').filter(function (x) { return s.opts.some(function (o) { return o.v === x; }); });
      });
      if (u.get('min')) state.min = +u.get('min') || 0;
      if (u.get('max')) state.max = +u.get('max') || Infinity;
      if (u.get('q')) { state.q = u.get('q'); var qi = $('[data-tm-q]'); if (qi) qi.value = state.q; }
    }
    apply();
    if (full && location.search) setTimeout(scrollToResults, 300);
  }).catch(function () {
    var rt = $('[data-tm-res-title]') || $('[data-tm-count]');
    if (rt) rt.innerHTML = 'Sorry — the finder couldn\'t load. <a href="/collections/all">Browse all products</a>.';
  });
})();
